<template>
  <div class="alert-message">
    <div>
      {{ `The domain is already in the always ${listName} list` }}
    </div>

    <div v-if="inputType === 'allow'"
         class="btn-group">
      <div class="btn btn-block"
           @click="$emit('keep')">
        {{ $t("keepBlock") }}
      </div>

      <div class="btn btn-allow"
           @click="$emit('move')">
        {{ $t("allow") }}
      </div>
    </div>

    <div v-if="inputType === 'block'"
         class="btn-group">
      <div class="btn btn-allow"
           @click="$emit('keep')">
        {{ $t("keepAllow") }}
      </div>

      <div class="btn btn-block"
           @click="$emit('move')">
        {{ $t("block") }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      inputType: {
        type: String,
        required: true
      }
    },

    computed: {
      listName() {
        return this.inputType === 'allow' ? 'block' : 'allow'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .alert-message {
    background: lighten(#f25b5b, 25%);
    display: flex;
    align-items: center;

    margin-bottom: 15px;
    padding: 0 0 16px 32px;
    font-size: 12px;

    .btn-group {
      display: flex;
      align-items: center;

      .btn {
        width: 80px;
        height: 25px;

        border-radius: 2px;
        padding: 7px 0;
        margin: 0 5px 0 12px;

        color: #fff;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
      }

      .btn-allow {
        background: #22c883;
      }

      .btn-block {
        background: #f35f5f;
      }
    }
  }
</style>
